import { useMutation } from '@tanstack/react-query';

import {
  deleteWorkspaceData,
  downloadWorkspaceDataExport,
  type DeleteWorkspaceDataInput,
  type WorkspaceExportFormat,
} from '../api/workspace-data.client.js';

export function useWorkspaceDataExportDownload() {
  return useMutation({
    mutationFn: (format: WorkspaceExportFormat) => downloadWorkspaceDataExport(format),
  });
}

export function useWorkspaceDataDelete() {
  return useMutation({
    mutationFn: (input: DeleteWorkspaceDataInput) => deleteWorkspaceData(input),
  });
}
